import { EmailsService } from "../services/EmailsService";
import { NotificationService } from "../services/NotificationService";
import { Page } from "./Page";
import { EmailTypes } from "../types/EmailTypes";

export class Form {

  formData;
  formEl;

  _loaderEl;
  _notificationsTexts;
  _emailType;
  _emailsService;
  _notificationService;
  _requiredFields;
  _gaEventType;
  _gaCategoryType;
  _selectBoxOptions;


  constructor(formEl, emailType, gaCategoryType, gaEventType) {
    this.formEl = formEl;
    this._emailType = emailType;
    this._gaEventType = gaEventType;
    this._gaCategoryType = gaCategoryType;
    this._emailsService = new EmailsService();
    this._notificationService = new NotificationService();
  }

  init() {
    this._loaderEl = this.formEl.querySelector('.loader');
    this._notificationsTexts = JSON.parse(this.formEl.getAttribute('data-notification'));
    this._requiredFields = Array.from(this.formEl.querySelectorAll('[data-required]'));

    this.requiredFieldsActions();
    this.submitForm();
  }

  prepareSelectBoxData() {
    const selectBoxInputChecked = this.formEl.querySelector('.select-box__input:checked');

    if (selectBoxInputChecked) {
      this.formData.append(selectBoxInputChecked.name, selectBoxInputChecked.value);
    }
  }

  requiredSelectBoxOptions() {
    this._selectBoxOptions.forEach(x => {
      if (x.value === 'none') {

        this.markElementAsInvalid(x);
      }
    });
  }

  requiredFieldsActions() {
    this._requiredFields.forEach(x => {
      x.addEventListener('change', () => {
        if (x.type === 'checkbox') {
          x.checked ? this.markElementAsValid(x) : this.markElementAsInvalid(x);
        } else {
          x.value === '' && (x.type !== 'file') ? this.markElementAsInvalid(x) : this.markElementAsValid(x);
          ['senderName', 'senderSurname'].includes(x.name) && x.value.length < 2 ? this.markElementAsInvalid(x, true) : this.markElementAsValid(x);
          if(x.name === 'senderEmail') {
            const emailInUseEl = document.querySelector('.contact-form__email-in-use');
            if(emailInUseEl) {
              emailInUseEl.classList.add('d-none')
            }
          }
        }
      });
    });
  }

  isFormValid() {
    return true;
  }

  submitForm() {
    this.formEl.addEventListener('submit', (e) => {
      e.preventDefault();

      this._requiredFields.forEach(this.markElementAsValid.bind(this));
      this._selectBoxOptions = this.formEl.querySelectorAll('.select-box__input:checked');

      this.requiredSelectBoxOptions();

      if (!this._requiredFields.every(x => x.type === 'checkbox' ? x.checked : (x.value !== '' && [...this._selectBoxOptions].every(x => x.value !== 'none')))) {

        this._requiredFields.filter(x => x.type === 'checkbox' ? !x.checked : x.value === '').forEach(x => {
          this.markElementAsInvalid(x);
        });

        this._requiredFields.filter(x => ['senderName', 'senderSurname'].includes(x.name) && x.value.length < 2).forEach(x => {
          this.markElementAsInvalid(x, true);
        });

        this._requiredFields.filter(x => x.type === 'radio' && x.value === 'none').forEach(x => {
          this.markElementAsInvalid(x);
        });

        return;
      }

      if (!this.isFormValid()) {
        return;
      }

      this._loaderEl.classList.remove('d-none');

      if (this._notificationEl) {
        this._notificationEl.close();
      }

      this.sendEmail();
    });
  }

  markElementAsInvalid(el, isMinLengthValidation = false) {
    const errorTextEl = document.createElement('div');
    const parentWithInvalidEl = el.type === 'checkbox' ? el.parentElement.parentElement : el.type === 'radio' ? el.parentElement.parentElement.parentElement : el.parentElement;

    el.type === 'radio' ? el.nextElementSibling.classList.add('form-field--invalid') : el.classList.add('form-field--invalid');
    errorTextEl.classList.add('invalid');

    if (!isMinLengthValidation) {
      errorTextEl.textContent = this.formEl.getAttribute('data-fields-error-text');
    } else {
      switch (Page.getLanguage()) {
        case 'en':
          errorTextEl.textContent = 'Value must have at least 2 characters';
          break;
        case 'pl':
          errorTextEl.textContent = 'Wartość musi mieć co najmniej 2 znaki';
          break;
        case 'de':
          errorTextEl.textContent = 'Wert muss mindestens 2 Zeichen enthalten';
          break;
      }
    }

    parentWithInvalidEl.append(errorTextEl);
  }

  markElementAsValid(el) {
    const parentWithInvalidEl = el.type === 'checkbox' ? el.parentElement.parentElement : el.type === 'radio' ? el.parentElement.parentElement.parentElement : el.parentElement;
    const errorTextElements = parentWithInvalidEl.querySelectorAll('.invalid');

    if (errorTextElements.length > 0) {
      el.classList.remove('form-field--invalid');
      errorTextElements.forEach(x => x.remove());
    }
  }

  prepareFormData() {

    this._selectBoxOptions.forEach(x => {
      this.formData.append(x.name, x.value);
    });

    this.formEl.querySelectorAll('.form-field:not([type="radio"])').forEach(({ name, value }) => {
      this.formData.append(name, value);
    });
  }

  showNotification() {

    const { success: { title, text } } = this._notificationsTexts;
    const fileNameMessageCv = document.getElementById('file-name-message');
    const selectBoxParagraph = document.querySelector('.select-box__value .select-box__input-text');

    this._notificationEl = this._notificationService.success(title, text);

    this.formEl.reset();

    if (fileNameMessageCv) {
      fileNameMessageCv.innerText = '';
    }

    if (selectBoxParagraph) {
      selectBoxParagraph.classList.remove('form-field--invalid');
    }
  }

  afterFormSendTracking() {
  }

  sendEmail() {
    this.formData = new FormData();
    this.formData.append('emailType', this._emailType);

    this.prepareFormData();

    if (this.formData.has('additionalParameters.language')) {
      this.formData.append('language', this.formData.get("additionalParameters.language"))
      this.formData.delete('additionalParameters.language')
    }

    if (!this.formData.has('language')) {
      this.formData.append('language', document.documentElement.lang);
    }

    this._emailsService.sendEmail(this.formData).then(() => {
      if (
        typeof ga === 'function' &&
        window['areCookiesPreferencesSet'] &&
        window['cookiesPreferences'].analyticsCookie
      ) {
        ga('send', 'event', this._gaCategoryType, this._gaEventType);
        dataLayer.push({ 'event': `cc_${ this._gaCategoryType }_${ this._gaEventType }` });
      }

      this.afterFormSendTracking();
      this.showNotification();
    }).catch((e) => {
      if (this._emailType === EmailTypes.RequestDemo) {
        this.afterFormSendTracking();
        this.showNotification('Email already in use' === e.response.data);
      } else {
        const { error: { title, text } } = this._notificationsTexts;
        this._notificationEl = this._notificationService.error(title, text);
      }
    }).finally(() => {
      this._loaderEl.classList.add('d-none');
      if(this._emailType !== EmailTypes.RequestDemo) {
        this.formEl.prepend(this._notificationEl);
      }
    });
  }
}
